'use strict';

(function() {
    var app = angular.module('webremote.login', []);

    
})();
